import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
  TASK_VEHICLE_LIST, TASK_VEHICLE_ADD, TASK_VEHICLE_DETAIL,
  TASK_VEHICLE_UPDATE, TASK_VEHICLE_FILTER_VEHICLES,
} from '../../actions';
import {
  TaskVehicleListSuccess, TaskVehicleListError,
  TaskVehicleAddSuccess, TaskVehicleAddError,
  TaskVehicleDetailSuccess, TaskVehicleDetailError,
  TaskVehicleUpdateSuccess, TaskVehicleUpdateError,
  TaskVehicleFilterVehiclesSuccess,
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/vehicle/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/vehicle/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/vehicle/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/vehicle/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onFilterVehiclesAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/vehicle/filter_vehicles', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(TaskVehicleListSuccess(response.data)); }
  catch (error) { yield put(TaskVehicleListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(TaskVehicleAddSuccess(response.data));
  } catch (error) { yield put(TaskVehicleAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(TaskVehicleDetailSuccess(response.data.data)); }
  catch (error) { yield put(TaskVehicleDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(TaskVehicleUpdateSuccess(response.data));
  } catch (error) { yield put(TaskVehicleUpdateError(error)); }
}

function* onFilterVehicles(data) {
  try { const response = yield call(onFilterVehiclesAsync, data.payload); yield put(TaskVehicleFilterVehiclesSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(TASK_VEHICLE_LIST, onList); }
export function* watchAdd() { yield takeEvery(TASK_VEHICLE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(TASK_VEHICLE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(TASK_VEHICLE_UPDATE, onUpdate); }
export function* watchFilterVehicles() { yield takeEvery(TASK_VEHICLE_FILTER_VEHICLES, onFilterVehicles); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate), fork(watchFilterVehicles)]);
}
